var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.0001 15C11.7953 15 11.5905 14.9183 11.4345 14.7558L8.23459 11.4226C7.9218 11.0968 7.9218 10.5702 8.23459 10.2444C8.54739 9.91855 9.05297 9.91855 9.36576 10.2444L12.0097 12.9984L14.644 10.3485C14.9632 10.0294 15.468 10.0385 15.7752 10.3694C16.0824 10.7002 16.0736 11.2285 15.756 11.5476L12.5561 14.7658C12.4001 14.9225 12.2001 15 12.0001 15Z","fill":"#323649"}));
}

Arrow.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
